import React, { FormEvent, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Switch } from '@chakra-ui/react';
import { HiCheck, HiX } from "react-icons/hi";
import logo from '../../assets/tech4humans.png';
import { SignInProps } from '../../utils/functionsInterfaces';
import { displayWarning } from '../../utils/messageToast';
import { useAuthContext } from '../../hooks/auth';
import { Select } from '../../components/ui/selects';
import style from './style.module.scss';
import { ButtonLogin } from '../../components/ui/buttons';

const Login: React.FC = () => {
  const { signIn } = useAuthContext();
  const [ambient, setAmbient] = useState('prod');
  const [slug, setSlug] = useState('');
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [inForce, setInForce] = useState(false);
  useEffect(() => {
    if (
      slug === "caixa" ||
      slug === "caixahml" ||
      slug === "canopushml" ||
      slug === "cnp" ||
      slug === "canopus" ||
      slug === "portohml" ||
      slug === "portovida" ||
      slug === "portoProdForce"
    ) {
      setInForce(true);
      setDisabled(true);
    } else if (slug === "porto") {
      setInForce(false);
      setDisabled(true);
    } else {
      setInForce(false);
      setDisabled(false);
    }
  }, [slug]);

  const [cacheCleared, setCacheCleared] = useState(false);
  const useIsomorphicEffect = useEffect;

  useIsomorphicEffect(() => {
    const executeClearCache = async () => {
      await clearCacheClient();
    };
    executeClearCache();
  }, []);

  const clearCacheClient = async () => {
    try {
      const cacheKeys = await caches.keys();
      if (cacheKeys.length > 0) {
        await Promise.all(cacheKeys.map(key => caches.delete(key)));
        setCacheCleared(true);
      }
    } catch (error: any) {
      return error
    }
  };

  const onSubmitWithReCAPTCHA = async (event: FormEvent) => {
    event.preventDefault();

    if (!slug) {
      displayWarning('Selecione o cliente!');
      return;
    }

    const dataLoginProps: SignInProps = {
      slug,
      ambient,
      inForce,
    };

    setLoading(true);

    await signIn(dataLoginProps);
    setLoading(false);
  };

  const handleInForceChange = () => {
    const newValue = !inForce;
    setInForce(newValue);
    localStorage.setItem("inForce", String(newValue));
  };

  return (
    <>
      <Helmet>
        <title>Tech Forms - Login</title>
      </Helmet>

      <div className={style.containerCenter}>
        <div className={style.login}>
          <img src={logo} alt="Logo Tech" />

          <form onSubmit={onSubmitWithReCAPTCHA}>

            <Select value={slug} onChange={(event) => {
              setSlug(event.target.value);
            }}>
              <option value="" disabled>
                Selecione o cliente
              </option>
              <option value="allianzflow">Allianz Produção</option>
              <option value="allianzflowhml">Allianz Homologação</option>
              <option value="canopus">Canopus Produção</option>
               <option value="canopushml">Canopus Homologação</option>
              <option value="tradicao">Tradicao Produção</option>
              <option value="mapfre">Mapfre Produção</option>
              <option value="mapfrehml">Mapfre Homologação</option>
              <option value="porto">Porto RC</option>
              <option value="portohml">Porto Bank Homologação Force</option>
              <option value="portoProdForce">Porto Bank Produção Force</option>
              <option value="unifisa">Unifisa Produção</option>
              <option value="multimarcas">Multimarcas Produção</option>
              {/* <option value="multimarcashml">Multimarcas Homologação</option> */}
              <option value="treinamentopa">Treinamento PA</option>
              <option value="hyperautomation">Hyperautomation</option>
              <option value="caixa">Caixa Produção</option>
              <option value="caixahml">Caixa Homologação</option>
              <option value="ouvidoria">Ouvidoria Produção</option>
              <option value="ouvidoriahml">Ouvidoria Homologação</option>
              {/* <option value="sisprime">Sisprime Produção</option>
              <option value="sisprimehml">Sisprime Homologação</option> */}
              <option value="portovida">Porto Vida Force</option>
              <option value="techpoc">Tech POC</option>
              <option value="cnp">CNP Produção</option>
            </Select>

            <Switch.Root
              size="lg"
              checked={inForce}
              disabled={disabled}
              onChange={handleInForceChange}
            >
              <Switch.Label style={{ color: 'white', fontSize: '1rem', fontWeight: 'bold' }}>
                Esta no force?
              </Switch.Label>
              <Switch.HiddenInput />
              <Switch.Control>
                <Switch.Thumb>
                  <Switch.ThumbIndicator fallback={<HiX color="black" />}>
                    <HiCheck color="black" />
                  </Switch.ThumbIndicator>
                </Switch.Thumb>
              </Switch.Control>
            </Switch.Root>

            <ButtonLogin type="submit" loading={loading}>
              Login
            </ButtonLogin>
          </form>

        </div>
      </div>
    </>
  );
};

export default Login;
